import React, { useEffect, useState } from "react";
import { getProducts } from "../../product/api/getProducts";
import ProductCard from "../../product/components/productCard";
import { Carousel } from "react-responsive-carousel"; // Import Carousel

import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import Carousel styles

const FeaturePage = ({ onQuantityChange }: any) => {
  const [productsData, setProductsData] = useState([]);

  const handleProducts = async () => {
    const response = await getProducts();

    // Filter products to show only those with 5 or fewer remaining items and active
    const filteredProducts = response.data.products.filter(
      (product: any) =>
        product.remaining_quantity <= 5 && product.is_active === 1
    );
    setProductsData(filteredProducts);
  };

  useEffect(() => {
    handleProducts();
  }, []);

  // Function to group products into sets of 5
  const groupProductsInSetsOfFive = (products: any[]) => {
    const grouped = [];
    for (let i = 0; i < products.length; i += 5) {
      grouped.push(products.slice(i, i + 5));
    }
    return grouped;
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-4 w-full text-center">
        المنتجات بكميات محدودة
      </h2>

      {productsData.length === 0 ? (
        <div className="text-center text-lg text-gray-600">
          لا توجد منتجات حالياً بكميات محدودة
        </div>
      ) : (
        <Carousel
          showArrows={true}
          showThumbs={false}
          dynamicHeight={false}
          infiniteLoop={true}
          useKeyboardArrows={true}
        >
          {groupProductsInSetsOfFive(productsData).map((group, index) => (
            <div key={index}>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 m-6">
                {group.map((product: any) => (
                  <ProductCard
                    key={product.id}
                    categoryId={product.category.id}
                    product={product}
                    onQuantityChange={onQuantityChange}
                  />
                ))}
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default FeaturePage;
